import * as React from 'react';
import { forwardRef, ComponentPropsWithoutRef } from 'react';
import clsx from 'clsx';

type GICheckboxPropsPicked =
  'id'
  | 'name'
  | 'onBlur'
  | 'onChange'
  | 'onFocus'
  | 'checked'
  | 'disabled'
  | 'required'
  | 'value'

export interface IGICheckboxProps extends Pick<ComponentPropsWithoutRef<'input'>, GICheckboxPropsPicked> {}

export const GICheckbox = forwardRef<HTMLInputElement, IGICheckboxProps>(function GICheckbox(
    {
        id,
        name,
        required = false,
        checked,
        value,
        onChange,
        disabled = false,
    },
    ref
) {
    const inputClassNames = clsx('usa-checkbox__input gi-checkbox__input required-{required}');
    return (
        <input
            id={id}
            name={name}
            aria-labelledby={id}
            checked={checked}
            className={inputClassNames}
            disabled={disabled}
            data-automation-id={id}
            data-testid={id}
            onChange={onChange}
            ref={ref}
            required={required}
            type='checkbox'
            role='checkbox'
            value={value}
        />
    );
});
